module.exports = __webpack_public_path__ + "img/logo_lockton_escuro.dfdc29be.svg";